export default {
    message: {
        "Ricerca_prodotti": "Products search",
        "Catalogo": "Catalog",
        "Area": "Area",
        "Categorie": "Categories",
        "Marchi": "Brands",
        "Stagione": "Season",
        "Prezzo": "Price",
        "Genere": "Gender",
        "Pagina": "Page",
        "di": "of",
        "Cerca": "Search",
        "vedi": "show",
        "totali": "totals",
        "Nessun prodotto trovato": "No products found",
        "Caricamento prodotti in corso": "Loading products",
        "Aggiungi al carrello": "Add to cart",
        "Loading": "Loading ...",
    },
}
